
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(484|526|89|912)|2(103|191|398|457|870)|6(322|396|706|770)|1(000|436|617|780)|3(034|346|488|573)|9(081|295|734)|(79|812|872)8|561)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
